import InfoSignatureStep2FormComponent from '../../components/info-signature/InfoSignatureStep2FormComponent';

export default function InfoSignatureStep2Bloc() {

      return (
        <div className="">
          <div className="">
            <h2 className="card-title bleu">Mes documents ont été signés : </h2>
             <InfoSignatureStep2FormComponent />
          </div>
        </div>
      )
}